import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onReady", "embeddedContext", "children"];
import { useEffect } from 'react';
import { IframeableContextProvider } from '../context/IframeableContext';
import UIEmbeddedComponent from 'ui-addon-iframeable/embed/UIEmbeddedComponent';
import { removeConversationsWidgetWhenAvailable } from '../utils/conversationsWidget';
import { getFullUrl } from 'hubspot-url-utils';
import enviro from 'enviro';
import { jsx as _jsx } from "react/jsx-runtime";
function IframeableContainer(_ref) {
  let {
      onReady,
      embeddedContext,
      children
    } = _ref,
    embeddedPassthruProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  useEffect(() => {
    onReady({
      data: {},
      receiveMessage: () => {}
    });
    // Remove conversations widget if present to prevent double loading
    removeConversationsWidgetWhenAvailable();
  }, []); /* eslint-disable-line react-hooks/exhaustive-deps */

  embeddedContext.passthruProps = {
    checkoutSession: embeddedPassthruProps.checkoutSession,
    checkoutFees: embeddedPassthruProps.checkoutFees,
    eventDate: embeddedPassthruProps.eventDate,
    eventDescription: embeddedPassthruProps.eventDescription
  };
  return /*#__PURE__*/_jsx(IframeableContextProvider, {
    iframeableContext: embeddedContext,
    children: children
  });
}

// In local dev origins won't match, so disable the allowlist and fall back to
// trusting the first sender. In deployed envs, restrict to the app origin for
// the running hublet (e.g. app.hubspot.eu in EU prod).
export const getAllowedParentOrigins = () => {
  if (!enviro.deployed()) {
    return undefined;
  }
  return [new URL(getFullUrl('app')).origin];
};
export default UIEmbeddedComponent(IframeableContainer, {
  allowedOrigins: getAllowedParentOrigins()
});